import React from 'react';
import useQuery from '../utilities/use-query';

const dim = (value) => (value ? String(value).split(',') : []);

export default React.memo(({on, children}) => {
  const {apply, applyOn} = useQuery();
  const applyDim = dim(applyOn || apply);
  return <>{applyDim.includes(on) && children}</>;
});
